import { FC } from "react"
import { ProfileComponent } from "../ProfileComponent"
import { useParams } from "react-router-dom"

export const UserManagementEditPage: FC = () => {
    const { id } = useParams()
    return <ProfileComponent mode='admin' userProfileId={id ?? ''} returnUrl={'/setting/users'} />
}